'use client';

import React from 'react';
import Container from '@mui/material/Container';
import FirstScreen from './first-screen';
import SecondScreen from './second-screen';
import ResumeEvaluation from './resume-evaluation';
import ResumeEdit from '@/components/resume/resume-marketing/ResumeEdit';
import ConsultClassify from '@/components/resume/resume-marketing/ConsultClassify';
import SeoTopSection from '@/components/seo/landing/Top';
import SeoLandingPage from '@/components/seo/landing';
import { SeoHotDataType } from '@/types/common';

const HomePage = (props: SeoHotDataType) => {
  const { hotJobTitles, hotCities, jobTitlesRank, hotJobs } = props;

  return (
    <>
      <FirstScreen />
      <SecondScreen />
      <ResumeEvaluation />
      <ResumeEdit />
      <ConsultClassify isConsultationBtnLink={true} />
      <SeoTopSection />
      <Container maxWidth="desktop">
        <SeoLandingPage
          hotJobTitles={hotJobTitles}
          hotCities={hotCities}
          jobTitlesRank={jobTitlesRank}
          hotJobs={hotJobs}
        />
      </Container>
    </>
  );
};

export default HomePage;
